import { useState } from "react";
import { Typography, Box } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
export default function OrderItems(props) {
  const [ordersRes, setOrdersRes] = useState(props.rows ? props.rows : []);

  const columns = [
    {
      field: "rowNO",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      // hide: true,
      sortable: false,
    },
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      hide: true,
      sortable: false,
    },
    {
      field: "productID",
      width: 100,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => window.open(cellValues.row.productURL, "_blank")}
          >
            <Typography variant="span" sx={{ whiteSpace: "normal", ml: 1 }}>
              {cellValues.row.productID}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "product",
      headerName: "نام محصول",
      width: props.OrderItems ? 250 : 400,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal", ml: 1 }}>
            {cellValues.row.product}
          </Typography>
        );
      },
    },
    {
      field: "brand",
      headerName: "نام برند",
      width: props.OrderItems ? 150 : 200,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal", ml: 1 }}>
            {cellValues.row.brand}
          </Typography>
        );
      },
    },
    {
      field: "count",
      headerName: "تعداد سفارش",
      width: 100,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
  ];

  return (
    <Box sx={{ height: props.OrderItems ? "20rem" : "25rem" }}>
      {ordersRes && (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={100}
          rows={ordersRes}
          page={0}
          rowCount={ordersRes && ordersRes.length ? ordersRes.length : 1}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              noPage: true,
              rowCount: ordersRes && ordersRes.length ? ordersRes.length : "",
            },
          }}
        />
      )}
    </Box>
  );
}
